import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, map, tap, switchMap } from 'rxjs';
import { OrganisationType } from '../../../core/models/organisation.model';
import { PageHeaderDropdownItem } from '../../../shared/page-header/page-header.model';
import { UsersService } from '../../users/user.service';
import { OrganizationApiService } from '../../../core/modules/organization/organization-api.service';
import { IOrganisation } from '../../../core/modules/organization/organization.types';
import { LanguageService } from '../../../core/services/language.service';

@Component({
  selector: 'tax-organization',
  templateUrl: './organization-page.component.html',
  styleUrls: ['./organization-page.component.sass'],
})
export class OrganizationPageComponent {
  readonly dropdownItems$: Observable<PageHeaderDropdownItem[]> = this.usersService.getCurrentUserInfo()
    .pipe(
      map(userInfo => [
        {
          action: () => {
            this.router.navigate(['/main/organization/edit']);
          },
          icon: 'edit',
          title: 'organization.edit',
          visibilityCondition: userInfo.uiPermissions?.editOrgData,
        },
      ]),
    );

  readonly organization$: Observable<IOrganisation> = this.getOrganizationData();

  organisationType = {
    isIndividual: false,
    isLegal: false,
  };

  constructor(
    private organizationApiService: OrganizationApiService,
    private router: Router,
    private usersService: UsersService,
    private languageService: LanguageService,
  ) {}

  private getOrganizationData(): Observable<IOrganisation> {
    return this.languageService.languageChanges.pipe(
      switchMap(() => this.organizationApiService.fetchOrganization()),
      tap((organisation) => {
        this.organisationType = {
          isIndividual: organisation.type.toString() === OrganisationType.Individual,
          isLegal: organisation.type.toString() === OrganisationType.Legal,
        };
      }),
    );
  }
}
